// extracted by mini-css-extract-plugin
export default {"incorrectBirth":"SignUpIncorrectBirthStep_incorrectBirth__Ky4uY9Nu","warning":"SignUpIncorrectBirthStep_warning__5SCJKUsi","back":"SignUpIncorrectBirthStep_back__kL3CjaIb"};